import api from './api';

const cartApi = {
  // Get full cart details
  getCart: async () => {
    const response = await api.get('/cart');
    return response.data;
  },

  // Get cart summary (item count and total)
  getCartSummary: async () => {
    const response = await api.get('/cart/summary');
    return response.data;
  },

  // Add item to cart
  addToCart: async (productId, quantity) => {
    const response = await api.post('/cart/items', {
      productId,
      quantity
    });
    return response.data;
  },

  // Update cart item quantity
  updateCartItem: async (itemId, quantity) => {
    const response = await api.put(`/cart/items/${itemId}`, {
      quantity
    });
    return response.data;
  },

  // Remove item from cart
  removeFromCart: async (itemId) => {
    const response = await api.delete(`/cart/items/${itemId}`);
    return response.data;
  },

  // Clear entire cart
  clearCart: async () => {
    await api.delete('/cart');
  }
};

export default cartApi;